import React, { Component, Fragment } from 'react';
import '../../../assets/css/fullcalendar.min.css'
import FullCalendar from 'fullcalendar-reactwrapper';
import { get, getRecipesDataByCode, formatNutritionFacts, getAllNutrientData} from '../../../server/actions'
import NotificationSystem from 'react-notification-system';
import Modal from 'react-modal';
import moment from 'moment';
import * as tz from 'moment-timezone';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../../assets/css/slider.css';
import {
    gradeTextToNumber, convertTwoDecimalPoint,
    _addNotificationError, isRegularLunchOrderType, groupBy, getParent_schoolFoodServiceInfo, getOrderCustomMessage, convertToTimezone, getSchoolTimeZone, getLoginModuleAccess, getItemizedAccess
} from '../../../server/util';
import { allergens, MealTypes, MenuOrderTypes } from '../../../server/constants.js'
import MonthCalender from '../../Misc/calender/monthCalender/monthCalender';
import NutritionCtrl from './nutritionCtrl'
import PropTypes from "prop-types";
import '../../Misc/calender/monthCalender/monthCalender.css';
import $ from 'jquery';
import CounterComponent from './CounterComponent';
import NutritioninfoNew from '../../SchoolAdmin/Caterer/MenuMaster/NutritionInfoNew';
import defaultImage from '../../../assets/meal-bg.jpg'
let scrollX = 0;
let scrollY = 0;
const styles = {
    imageStyle: {
        height: '30px',
        width: '30px',
    },
    eggImageStyle: {
        height: '30px',
        width: '20px',
    },
    fishImageStyle: {
        height: '18px',
        width: '30px',
    },
    fishStyle: {

        display: "flex", alignItems: "center", padding: '9px 6px', borderRadius: "50%", border: "none !important"
    },
    allergensButtonStyle: {
        display: "flex", alignItems: "center", padding: '5px 5px', borderRadius: "50%", border: "none !important"
    },
    eggButtonStyle: {
        display: "flex", alignItems: "center", padding: '5px 9px', borderRadius: "50%", border: "none !important"
    }
}
const MealTypesText = {
    MEAL: 'Main course',
    SNACK: 'Snack',
    BREAKFAST: 'Breakfast',
    DINNER: 'Dinner',
    SIDE: 'Sides',
    EXTRA: 'A La Carte ',
    HOLIDAY: 'Holiday',
    ENTREE: "Entree",
    FRUIT: 'Fruit',
    MILK: 'Milk',
    VEGETABLES: "Vegetables"
}
const MTypes = {
    meal: 'MEAL',
    snack: 'SNACK',
    dinner: 'DINNER',
    breakfast: 'BREAKFAST',
    side: 'SIDE',
    extra: 'EXTRA',
    holiday: 'HOLIDAY',
    entree: "ENTREE",
    fruit: "FRUIT",
    milk: "MILK",
    vegetables: "VEGETABLES",

};
const customStyles = {
    content: {
        textAlign: 'justify',
        textJustify: 'inter-word',
        padding: '30px',
        maxHeight: '500px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
let dot = {
    backgroundColor: '#b2e87a',
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0px 10px',
    verticalAlign: 'middle'

}
let allergyDot = {
    backgroundColor: '#f36d6d',
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: '10px'

}
let dot2 = {
    backgroundColor: 'orange',
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0px 10px',
    verticalAlign: 'middle'

}
let dot3 = {
    backgroundColor: '#ea7066',
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0px 10px',
    verticalAlign: 'middle'

};
let dot4 = {
    height: '25px',
    width: '25px',
    border: 'solid 2px',
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0px 7px',
    verticalAlign: 'middle'
};
let showM_SLegend = true;
const infoModalStyles = {
    content: {
        overflow: 'auto',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '50%',
        height: '100%',
        maxHeight: '80vh',
        transform: 'translate(-50%, -50%)',
    }
};
const mealItemObj = {
    "itemId": sessionStorage.getItem('menuItemId'),
    "calcium": 0,
    "calories": 0,
    "cholestral": 0,
    "copper": 0,
    "dietaryFiber": 0,
    "folate": 0,
    "iron": 0,
    "magnesium": 0,
    "manganese": 0,
    "niacin": 0,
    "pantothenicAcid": 0,
    "phosphorous": 0,
    "potassium": 0,
    "protein": 0,
    "riboFlavin": 0,
    "saturatedFat": 0,
    "selenium": 0,
    "sodium": 0,
    "sugars": 0,
    "thiamin": 0,
    "totalCarbohydrate": 0,
    "totalFat": 0,
    "vitaminA": 0,
    "vitaminB6": 0,
    "vitaminB12": 0,
    "vitaminC": 0,
    "vitaminD": 0,
    "vitaminE": 0,
    "vitaminK": 0,
    "zinc": 0,
    "isNutrAvailable": true,
}
export const newCategories = [MTypes.entree, MTypes.fruit, MTypes.milk, MTypes.vegetables]
class OrderCalender extends Component {
    constructor(props) {
        super(props);
        let schoolID = 0
        if (this.props.isParent) {
            console.log("school id-==============", this.props.studentData.mealSchoolId)
            schoolID = this.props.studentData.mealSchoolId

        }
        const isItemized = getItemizedAccess(schoolID)
        this.state = {
            menuObj: this.props.dataSet,
            allergyAlertModal: false,
            activeSlide: 0,
            isCutoffModeOpen: false,
            nutritionInfoIsOpen: false,
            menuItemId: 0,
            menuItemRec: JSON.parse(JSON.stringify(mealItemObj)),
            foodServiceInfo: {},
            isItemized,
            showPrePayAlert: false,
            nutritionCodeVal: {},
            nutritionVal: [],
            servings: {},
            nutritonMasterList: []
        }

        this.eventStyles = this.eventStyles.bind(this);
        this.selectEvent = this.selectEvent.bind(this);
        this.updateQuantity = this.updateQuantity.bind(this);
        this.showNutritionInfoOpen = this.showNutritionInfoOpen.bind(this);
        this.hideshowNutritionInfoOpen = this.hideshowNutritionInfoOpen.bind(this);
    }
    componentWillMount = () => {
        showM_SLegend = isRegularLunchOrderType(this.props.studentData.mealSchoolId) ? true : false;
        const { id } = this.context.router.route.match.params;

        let _menuItemId = 0;
        const foodServiceInfo = getParent_schoolFoodServiceInfo(this.props.studentData.mealSchoolId)
        try {
            if (parseInt(id) > 0) {
                _menuItemId = parseInt(id);
            }
        } catch (ex) {
        }
        this.setState({ menuItemId: _menuItemId, foodServiceInfo }, () => {
            if ((_menuItemId || 0) > 0) {
                // this.getNutritionInfo(_menuItemId);
            }
        });
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.getNutritionMasterList();
    }
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            menuObj: nextProps.dataSet
        });
    }
    componentWillUpdate = () => {
        const id = `#mCal-${Object.keys(this.state.menuObj)[this.state.activeSlide]}`;
        scrollX = $(document).find(id).parent().scrollLeft() || 0;
        scrollY = $(document).scrollTop();
    }
    componentDidUpdate = () => {
        const id = `#mCal-${Object.keys(this.state.menuObj)[this.state.activeSlide]}`;
        $(document).find(id).parent().scrollLeft(scrollX);
        window.scrollTo(scrollX, scrollY);
        /*  if (!isMobile){
             this.slider.slickGoTo(Object.keys(this.state.orderHistory).length || 0);
         } */
    }
    showNutritionInfoOpen = (_menuItem) => {
        this.setState({ menuItem: _menuItem, nutritionInfoIsOpen: true })
    }
    hideshowNutritionInfoOpen = () => {
        this.setState({ nutritionInfoIsOpen: false });
    }
    getNutritionMasterList = async () => {
        const nutList = [];
        const res = await getAllNutrientData();
        if (!res.error) {
          const resp = res.data || [];
          resp.map(itm => {
            nutList.push({
              ...itm,
              nutrientDescriptions: [
                {
                  nutrientDescription: `${itm.nutrientDescription}`,
                  nutrientUnit: `${itm.units}`
                }
              ]
            });
            if ((itm.subNutrients || []).length > 0) {
              (itm.subNutrients || []).map(sitm => {
                nutList.push({
                  parent: itm.nutrientCode,
                  ...sitm,
                  nutrientDescriptions: [
                    {
                      nutrientDescription: `${sitm.nutrientDescription}`,
                      nutrientUnit: `${sitm.units}`
                    }
                  ]
                });
              });
            }
          })
          this.setState({nutritonMasterList: [...nutList]});
        }
      }
    getNutritionInfo = (menuItemId) => {
        this.setState({ loading: true, menuItemRec: { ...mealItemObj, itemId: menuItemId } });
        get(`/menuItems/${menuItemId}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let _menuItemRec = data || {};
            let _mealRec = JSON.parse(JSON.stringify({ ...mealItemObj, itemId: menuItemId }));
            _mealRec = { ..._mealRec, ..._menuItemRec }

            this.setState({ loading: false, menuItemRec: { ..._mealRec } })
            if(_mealRec.sourceRecipeId === undefined){
                this.setState({ menuItemRec: { ...this.state.menuItemRec, imageUrl:null  }, nutritionVal: [] });
            }else{            
            getRecipesDataByCode(_mealRec.sourceRecipeId).then((resp) => {
                if (!resp.ok) {
                    throw Error(resp.statusText);
                }
                return resp.json();
            }).then(respData => {
                let nutritionData = [];
                nutritionData = formatNutritionFacts((this.state.nutritonMasterList || []), (respData.nutrientValues || []), true, ((respData || []).servings || {}).size || 0);
                const result = nutritionData.reduce((acc, item) => {
                    acc[item.nutrientCode] = item.nutrientValue;
                    return acc;
                }, {});
                this.setState({ menuItemRec: { ...this.state.menuItemRec, nutritionData, imageUrl:respData.imageUrl } })
                this.setState({ nutritionCodeVal: { ...result } });
                this.setState({nutritionVal: nutritionData});
                this.setState({servings: respData.servings});
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                })
            }
        }).catch(
            (error) => {
                this.setState({ loading: false })
                console.log('Get NutritionInfo response', error)
            }
        );
    }
    validateDates = (calEvent) => {
        const { isPaymentPending } = this.props;
        const _menuObj = { ...this.state.menuObj };
        const activeMonthMenuObj = _menuObj[Object.keys(_menuObj)[this.state.activeSlide]] || {};
        if ((calEvent.toDate().getDate() < activeMonthMenuObj.startingDayOfMenuSelection) || !activeMonthMenuObj.startingDayOfMenuSelection) {
            return true;
        } else {
            if (isPaymentPending) {
                return true
            }
            return false;
        }
    }
    validatePrePayOrder = (currentPrice = 0.0) => {
        const { initialPrices, price, studentData, isPrePayForOrderStatus, isInstantPayment, isParent } = this.props;
        if (isPrePayForOrderStatus && isParent && isInstantPayment) {
            const accBalance = studentData.accBalance || 0.00;
            let initPriceTotal = 0.0;
            Object.keys((initialPrices || {})).map(key => {
                initPriceTotal += parseFloat(initialPrices[key]);
            });
            let selectedTotal = 0.0;
            Object.keys((price || {})).map(key => {
                selectedTotal += parseFloat(price[key]);
            });
            let balAmt = 0.0;
            balAmt = (currentPrice + selectedTotal - initPriceTotal);
            if ((accBalance - balAmt) < 0) {
                this.setState({ showPrePayAlert: true });
                return true;
            }
            return false;
        }
        return false;
    }
    updateQuantity(item, count, action) {
        if (action != 'decrement') {
            if (this.validatePrePayOrder(item.price)) {
                return false;
            }
        }
        const _menuObj = { ...this.state.menuObj };
        let menus = _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList
        if (item.type === "SIDE") {
            const MEALTypeMenu = menus.find(menu => item.date === menu.date && menu.isSelected && ["MEAL", 'SNACK', 'BREAKFAST'].includes(menu.type))
            if (MEALTypeMenu) {
                if (MEALTypeMenu.quantity < count) {
                    _addNotificationError('Sides quantity should be less than or equal to Entree quantity.', this)
                    return false
                }
            }
        }
        const _menus = menus.map(menu => {

            if (menu.id === item.id && menu.date === item.date) {
                menu.quantity = count
            }
            if (["MEAL", 'SNACK', 'BREAKFAST', 'DINNER'].includes(item.type) && action === 'decrement') {
                if (menu.type === "SIDE" && menu.date === item.date && menu.isSelected && menu.quantity > count) {
                    menu.quantity = count
                }
            }
            return menu
        })

        _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = _menus;
        this.props.onMenuSelectionChange(_menuObj);

        return true;
    }

    selectEvent = (calEvent, jsEvent, view) => {
        if (calEvent.allergyAlert && !calEvent.isSelected) {
            this.setState({
                allergyAlertModal: true
            })
        }
        const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((calEvent.type === MealTypes.BREAKFAST.toUpperCase()) && this.props.studentData.beforeCare) ? true : false);
        const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
        const _menuObj = { ...this.state.menuObj };
        const { isMultiSelect } = this.props;
        let menu = _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList;

        //jsEvent.preventDefault();
        //jsEvent.stopPropagation();
        if (this.validateDates(calEvent.start)) {
            return;
        }

        const unSelectSides = (list) => {
            (list.filter(x => {
                return x.date === calEvent.date && x.type == 'SIDE'
            }) || []).map(item => {
                item.isSelected = false
                item.quantity = 1
            });
            return list;
        }


        //MealIems//
        if (newCategories.includes(calEvent.type) || calEvent.type == "MEAL" || calEvent.type === MenuOrderTypes.ITEMIZE.toUpperCase() || calEvent.type === MealTypes.SNACK.toUpperCase() || calEvent.type === MealTypes.BREAKFAST.toUpperCase() || calEvent.type === MealTypes.DINNER.toUpperCase()) {
            const idx = menu.findIndex(x => {
                return x.eventId === calEvent.eventId
            });
            let updatedEvent = { ...menu[idx], isSelected: !calEvent.isSelected }
            if (!updatedEvent.isSelected) {
                updatedEvent.quantity = updatedEvent.quantity || 1
            } else {
                updatedEvent.quantity = 1
            }
            let nextEvents = [...menu]
            let calDate = calEvent.start._d;
            let calTitle = calEvent.title;
            nextEvents.splice(idx, 1, updatedEvent);
            if (studentIsFreeMeal) {
                if (updatedEvent.isSelected) {
                    if (!isMultiSelect) {
                        Object.keys(menu).map(item => {
                            if (menu[item].start.format('YYYYMMDD') == moment(calDate).format('YYYYMMDD') && menu[item].type !== 'EXTRA'
                                && (newCategories.includes(menu[item].type) || menu[item].type == 'MEAL' || calEvent.type === MenuOrderTypes.ITEMIZE.toUpperCase() || calEvent.type === MealTypes.SNACK.toUpperCase() || calEvent.type === MealTypes.BREAKFAST.toUpperCase() || calEvent.type === MealTypes.DINNER.toUpperCase())) {
                                if (!(menu[item].title == calTitle)) {
                                    if (menu[item].isSelected == true) {
                                        updatedEvent = { ...menu[item], isSelected: false }

                                        nextEvents.splice(item, 1, updatedEvent);
                                    }
                                }
                            }
                        });
                    }

                    if (this.validatePrePayOrder(0)) {
                        updatedEvent.isSelected = false;
                        return false;
                    } else {
                        _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = nextEvents
                        this.props.onMenuSelectionChange(_menuObj);
                    }
                } else {
                    _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = unSelectSides(nextEvents)
                    this.props.onMenuSelectionChange(_menuObj);
                }
            }
            else if (studentIsReducePrice) {
                if (updatedEvent.isSelected) {
                    if (!this.props.isMultiSelect) {
                        Object.keys(menu).map(item => {
                            if (menu[item].start.format('YYYYMMDD') == moment(calDate).format('YYYYMMDD') && menu[item].type !== 'EXTRA'
                                && (newCategories.includes(menu[item].type) || menu[item].type == 'MEAL' || calEvent.type === MealTypes.SNACK.toUpperCase() || calEvent.type === MealTypes.BREAKFAST.toUpperCase() || calEvent.type === MealTypes.DINNER.toUpperCase())) {
                                if (!(menu[item].title == calTitle)) {
                                    if (menu[item].isSelected == true) {
                                        updatedEvent = { ...menu[item], isSelected: false }
                                        nextEvents.splice(item, 1, updatedEvent);
                                    }
                                }
                            }
                        });
                    }

                    if (this.validatePrePayOrder(updatedEvent.reducedPrice)) {
                        updatedEvent.isSelected = false;
                        return false;
                    } else {
                        _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = nextEvents;
                        this.props.onMenuSelectionChange(_menuObj);
                    }
                } else {
                    _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = unSelectSides(nextEvents)
                    this.props.onMenuSelectionChange(_menuObj);
                }

            }
            else {
                if (updatedEvent.isSelected) {
                    if (!isMultiSelect) {
                        Object.keys(menu).map(item => {
                            if (menu[item].start.format('YYYYMMDD') == moment(calDate).format('YYYYMMDD') && menu[item].type !== 'EXTRA') {
                                if (!(menu[item].title == calTitle)) {
                                    if (menu[item].isSelected == true) {
                                        updatedEvent = { ...menu[item], isSelected: false, quantity: 1 }
                                        nextEvents.splice(item, 1, updatedEvent)
                                    }
                                }
                            }
                        });
                    }
                    nextEvents = nextEvents.map(item => {
                        if (item.date === updatedEvent.date) {
                            item.quantity = item.quantity || 1
                        }
                        return item
                    })
                    if (this.validatePrePayOrder(updatedEvent.price)) {
                        updatedEvent.isSelected = false;
                        return false;
                    } else {
                        _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = nextEvents
                        this.props.onMenuSelectionChange(_menuObj);
                    }
                } else {
                    _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = unSelectSides(nextEvents)
                    this.props.onMenuSelectionChange(_menuObj);
                }
            }
        }
        //MealItemsEnd//        
        //ExtraItems//
        if (calEvent.type == "EXTRA") {
            const exIdx = menu.findIndex(x => {
                return x.eventId === calEvent.eventId
            });
            let exupdatedEvent = { ...menu[exIdx], isSelected: !calEvent.isSelected }
            if (!calEvent.isSelected) {
                exupdatedEvent.quantity = 1;
            } else {
                exupdatedEvent.quantity = 0;
            }
            let exnextEvents = [...menu]
            let excalDate = calEvent.start._d;
            let calTitle = calEvent.title;
            exnextEvents.splice(exIdx, 1, exupdatedEvent);
            if (studentIsFreeMeal || studentIsReducePrice) {
                if (exupdatedEvent.isSelected) {
                    if (isMultiSelect) {
                        Object.keys(menu).map(item => {
                            if (menu[item].start.format('YYYYMMDD') == moment(excalDate).format('YYYYMMDD')
                                && (menu[item].type == 'EXTRA')) {
                                if (!(menu[item].title == calTitle)) {
                                    if (menu[item].isSelected == true) {
                                        exupdatedEvent = { ...menu[item], isSelected: false }
                                        exnextEvents.splice(item, 1, exupdatedEvent);
                                    }
                                }
                            }
                        });
                    }
                    exnextEvents = exnextEvents.map(item => {
                        if (item.date === exupdatedEvent.date) {
                            item.quantity = item.quantity || 1
                        }
                        return item
                    })

                    if (this.validatePrePayOrder(exupdatedEvent.price)) {
                        exupdatedEvent.isSelected = false;
                        return false;
                    } else {
                        _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = exnextEvents
                        this.props.onMenuSelectionChange(_menuObj);
                    }
                } else {
                    _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = exnextEvents
                    this.props.onMenuSelectionChange(_menuObj);
                }
            } else {

                if (exupdatedEvent.isSelected) {
                    if (isMultiSelect) {
                        Object.keys(menu).map(item => {
                            if (menu[item].start.format('YYYYMMDD') == moment(excalDate).format('YYYYMMDD')) {
                                if (!(menu[item].title == calTitle)) {
                                    if (menu[item].isSelected == true) {
                                        exupdatedEvent = { ...menu[item], isSelected: false }
                                        exnextEvents.splice(item, 1, exupdatedEvent)
                                    }
                                }
                            }
                        });
                    }

                    if (this.validatePrePayOrder(exupdatedEvent.price)) {
                        exupdatedEvent.isSelected = false;
                        return false;
                    } else {
                        _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = exnextEvents
                        this.props.onMenuSelectionChange(_menuObj);
                    }
                } else {
                    _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = exnextEvents
                    this.props.onMenuSelectionChange(_menuObj);
                }
            }

        }
        //ExtraItemsEnd//

        //SideItems//
        else if (calEvent.type == "SIDE") {
            const idx = menu.findIndex(x => x.eventId === calEvent.eventId);
            let updatedEvent = { ...menu[idx], isSelected: !calEvent.isSelected }
            let nextEvents = [...menu]
            let calDate = calEvent.start;
            let calTitle = calEvent.title;
            nextEvents.splice(idx, 1, updatedEvent);
            if (updatedEvent.isSelected) {
                let isMenuSelected = false;
                isMenuSelected = (menu || []).some(item => {
                    if (item.start.format('YYYYMMDD') == moment(calDate).format('YYYYMMDD')
                        && (newCategories.includes(item.type) || item.type == 'MEAL' || item.type == 'SNACK' || item.type == 'BREAKFAST' || calEvent.type === MenuOrderTypes.ITEMIZE.toUpperCase() || calEvent.type === MealTypes.SNACK.toUpperCase() || calEvent.type === MealTypes.BREAKFAST.toUpperCase()) && item.isSelected == true) {
                        return true;
                    }
                    return false;
                });
                if (!isMenuSelected) {
                    _addNotificationError('Please select Entree item first on (' + moment(calEvent.start).format('DD-MM-YYYY') + ').', this)
                    return false;
                }
                if (!isMultiSelect) {
                    Object.keys(menu).map(item => {
                        if (menu[item].start.format('YYYYMMDD') == moment(calDate).format('YYYYMMDD') && menu[item].type == "SIDE") {
                            if (!(menu[item].title == calTitle)) {
                                if (menu[item].isSelected == true) {
                                    updatedEvent = { ...menu[item], isSelected: false }
                                    nextEvents.splice(item, 1, updatedEvent)
                                }
                            }
                        }
                    });
                }
                nextEvents = nextEvents.map(item => {
                    if (item.date === updatedEvent.date) {
                        item.quantity = item.quantity || 1
                    }
                    if (!item.isSelected) item.quantity = 1
                    return item
                });

                if (this.validatePrePayOrder(updatedEvent.price)) {
                    updatedEvent.isSelected = false;
                    return false;
                } else {
                    _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = nextEvents
                    this.props.onMenuSelectionChange(_menuObj);
                }
            } else {
                _menuObj[Object.keys(_menuObj)[this.state.activeSlide]].menuItemsList = nextEvents
                this.props.onMenuSelectionChange(_menuObj);
            }
        }

        //SideItemsEnd//
    }
    eventStyles(event, element, view) {
        const mLegend = (showM_SLegend) ? 'M : ' : '';
        const sLegend = (showM_SLegend) ? 'S : ' : '';
        const eLegend = (showM_SLegend) ? 'E : ' : '';
        const currency = this.props.currency_symbol;
        const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((event.type === MealTypes.BREAKFAST.toUpperCase()) && this.props.studentData.beforeCare) ? true : false);
        const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
        //MealIems//
        if ((newCategories.includes(event.type) || event.type === "MEAL" || event.type === MenuOrderTypes.ITEMIZE.toUpperCase() || event.type === MealTypes.SNACK.toUpperCase() || event.type === MealTypes.BREAKFAST.toUpperCase() || event.type === MealTypes.DINNER.toUpperCase()) && !event.isSelected) {
            if (this.validateDates(event.start)) {
                return $('<a href="javascript:void(0)" title="' + event.desc + '"></span><div class="calender-menu-item-1" style="background-color: #e9efe3;"> ' + mLegend + ''
                    + event.title + "  " + currency
                    + convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? event.reducedPrice : event.price) + '</div></a>');

            }
            if (event.desc !== null && event.desc !== '') {
                if (event.allergyAlert !== null && event.allergyAlert !== undefined && event.allergyAlert !== '' && event.allergyAlert) {
                    return $('<a href="javascript:void(0)" title="' + event.desc + '"><div class="calender-menu-item-1" style="background-color: #f36d6d;"> ' + mLegend + ''
                        + event.title + "  " + currency
                        + convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? event.reducedPrice : event.price) + '</div></a>');
                } else {
                    return $('<a href="javascript:void(0)" title="' + event.desc + '"><div class="calender-menu-item-1"> ' + mLegend + ''
                        + event.title + "  " + currency
                        + convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? event.reducedPrice : event.price) + '</div></a>');
                }
            } else {
                return $('<div class="eventip calender-menu-item-2"> ' + mLegend + ''
                    + event.title + "  " + currency + convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? event.reducedPrice : event.price) + '</div>');
            }
        }
        else if ((newCategories.includes(event.type) || event.type === "MEAL" || event.type === MenuOrderTypes.ITEMIZE.toUpperCase() || event.type === MealTypes.SNACK.toUpperCase() || event.type === MealTypes.BREAKFAST.toUpperCase() || event.type === MealTypes.DINNER.toUpperCase()) && event.isSelected) {
            if (event.start._d < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {
                return $('<a href="javascript:void(0)" title="' + (event.desc == undefined ? '' : event.desc) + '"><div class="calender-menu-item-3" style="background-color: #ecd5a9;"> ' + mLegend + ''
                    + event.title + "  " + currency + convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? event.reducedPrice : event.price) + '</div></a>');
            }
            else {
                return $('<a style="cursor:pointer;" title="' + (event.desc == undefined ? '' : event.desc) + '"><div class="calender-menu-item-3"> ' + mLegend + ''
                    + event.title + "  " + currency + convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? event.reducedPrice : event.price) + '</div></a>');
            }
        }
        //MealIemsEnd//

        //ExtraItems//
        if ((event.type === "EXTRA" || event.type === MenuOrderTypes.ITEMIZE.toUpperCase() || event.type === MealTypes.SNACK.toUpperCase() || event.type === MealTypes.BREAKFAST.toUpperCase() || event.type === MealTypes.DINNER.toUpperCase()) && !event.isSelected) {
            if (this.validateDates(event.start)) {
                return $('<a href="javascript:void(0)" title="' + event.desc + '"></span><div class="calender-menu-item-1" style="background-color: #e9efe3;"> E : '
                    + event.title + "  " + currency + convertTwoDecimalPoint(event.price)
                    + '</div></a>');

            }
            if (event.desc !== null && event.desc !== '') {
                if (event.allergyAlert !== null && event.allergyAlert !== undefined && event.allergyAlert !== '' && event.allergyAlert) {
                    return $('<a href="javascript:void(0)" title="' + event.desc + '"><div class="calender-menu-item-1" style="background-color: #f36d6d;"> E : '
                        + event.title + "  " + currency
                        + convertTwoDecimalPoint(event.price) + '</div></a>');
                } else {
                    return $('<a href="javascript:void(0)" title="' + event.desc + '"><div class="calender-menu-item-1"> E : '
                        + event.title + "  " + currency
                        + convertTwoDecimalPoint(event.price) + '</div></a>');
                }
            } else {
                return $('<div class="eventip calender-menu-item-2"> E : '
                    + event.title + "  " + currency + convertTwoDecimalPoint(event.price) + '</div>');
            }
        }
        else if ((event.type === "EXTRA" || event.type === MenuOrderTypes.ITEMIZE.toUpperCase() || event.type === MealTypes.SNACK.toUpperCase() || event.type === MealTypes.BREAKFAST.toUpperCase() || event.type === MealTypes.DINNER.toUpperCase()) && event.isSelected) {
            if (event.start._d < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {
                return $('<a href="javascript:void(0)" title="' + (event.desc == undefined ? '' : event.desc) + '"><div class="calender-menu-item-3" style="background-color: #ecd5a9;"> E : '
                    + event.title + "  " + currency + convertTwoDecimalPoint(event.price) + '</div></a>');
            }
            else {
                return $('<a style="cursor:pointer;" title="' + (event.desc == undefined ? '' : event.desc) + '"><div class="calender-menu-item-3"> E : '
                    + event.title + "  " + currency + convertTwoDecimalPoint(event.price) + '</div></a>');
            }
        }

        //ExtraItemsEnd//
        //SideItems//
        else if (event.type === "SIDE") {
            if (event.isSideSelect) {
                if (!event.isSelected) {
                    if (this.validateDates(event.start)) {
                        return $('<a href="javascript:void(0)" title="' + event.desc + '"><div class="calender-menu-item-1" style="background-color: #e9efe3;"> ' + sLegend + ''
                            + event.title + '</div></a>');

                    } else {
                        return $('<div class="eventip calender-menu-item-2"> S : '
                            + event.title + '</div>');
                    }
                } else {
                    if (this.validateDates(event.start)) {
                        return $('<a href="javascript:void(0)" title="' + (event.desc == undefined ? '' : event.desc) + '"><div class="calender-menu-item-3" style="background-color: #ecd5a9;"> ' + sLegend + ''
                            + event.title + '</div></a>');
                    }
                    else {
                        return $('<a href="javascript:void(0)" title="' + (event.desc == undefined ? '' : event.desc) + '"><div class="calender-menu-item-3"> ' + sLegend + '' + event.title + '</div></a>');
                    }

                }

            } else {
                return $('<div style="border:0px; font-weight:bolder; white-space:pre-wrap; color:red; font-size:12px; margin-bottom:-5px;"> ' + sLegend + ''
                    + event.title + '</div>');
                /* element.css('background-color', 'inherit');
                element.css('border', '0px');
                element.css('font-weight', 'bolder');
                element.css('white-space', 'pre-wrap');
                element.css('color', 'red');
                element.css('font-size', '12px');
                element.css(' margin-bottom', '-5px'); */
            }
        }
        //SideItemsEnd//

    }
    compare = (a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    }

    renderDayEventList = (eventsObj, eventDate) => {
        const currency = this.props.currency_symbol;

        return (
            <Fragment>
                {
                    (eventsObj[MTypes.meal] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.meal]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.meal] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                    const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && this.props.studentData.beforeCare) ? true : false);
                                    const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
                                    const isDisabled = this.validateDates(eventDate);
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    const nutritionInfo = ((item.isNutrAvailable || '') !== '' && item.isNutrAvailable) ? true : false;
                                    return (<div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                        <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}> <div className={item.isSelected ? (isDisabled ? "menuItem active disabled" : "menuItem active") : (isDisabled ? "menuItem disabled" : "menuItem")}
                                            style={allergy ? (item.isSelected ? { backgroundColor: '#e5710d' } : { backgroundColor: '#f36d6d' }) : {}} onClick={(e) => {

                                                if (e._targetInst.type == 'i') {

                                                } else {
                                                    this.selectEvent(item);
                                                }
                                            }}>{
                                                <Fragment>

                                                    <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount && item.isSelected ? item.price : item.price))}` + `${" "}`}
                                                        {((nutritionInfo) ? <a title="Nutrition Info"
                                                            href onClick={(e) => {
                                                                const menuItemId = item.id
                                                                sessionStorage.setItem('menuItemId', menuItemId)
                                                                this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                this.getNutritionInfo(menuItemId)
                                                            }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a> : <a title="Nutrition Info"
                                                            href onClick={(e) => {
                                                                const menuItemId = item.id
                                                                sessionStorage.setItem('menuItemId', menuItemId)
                                                                this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                this.getNutritionInfo(menuItemId)
                                                            }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a>)}</span>

                                                    <div>
                                                        <span className="tooltiptext" style={{ marginLeft: 'auto' }}>{(item.desc || '').length > 0 ? item.desc : item.name}</span>
                                                    </div>



                                                </Fragment>
                                            }</div>  </div> {((this.state.isItemized === 1 || this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={isDisabled} updateQuantity={this.updateQuantity} item={item} /> </div>}
                                    </div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    Object.keys(eventsObj).map(keyName => {
                        if (!newCategories.includes(keyName)) {
                            return null
                        }
                        const menuList = eventsObj[keyName] || []
                        return (menuList || []).length > 0 ?
                            <Fragment>
                                <p className="groupTitle">
                                    <small>{MealTypesText[keyName]}</small>
                                    <hr className="menuItemDivision" />
                                </p>
                                {
                                    (menuList || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                        const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && this.props.studentData.beforeCare) ? true : false);
                                        const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
                                        const isDisabled = this.validateDates(eventDate);
                                        const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                        const nutritionInfo = ((item.isNutrAvailable || '') !== '' && item.isNutrAvailable) ? true : false;
                                        return (<div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                            <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}> <div className={item.isSelected ? (isDisabled ? "menuItem active disabled" : "menuItem active") : (isDisabled ? "menuItem disabled" : "menuItem")}
                                                style={allergy ? (item.isSelected ? { backgroundColor: '#e5710d' } : { backgroundColor: '#f36d6d' }) : {}} onClick={(e) => {

                                                    if (e._targetInst.type == 'i') {

                                                    } else {
                                                        this.selectEvent(item);
                                                    }
                                                }}>{
                                                    <Fragment>

                                                        <span
                                                         onMouseEnter={this.handleMouseEnter}
                                                         onMouseLeave={this.handleMouseLeave} >
                                                        {`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount && item.isSelected ? item.price : item.price))}` + `${" "}`}
                                                            {((nutritionInfo) ? <a title="Nutrition Info"
                                                                href onClick={(e) => {
                                                                    const menuItemId = item.id
                                                                    sessionStorage.setItem('menuItemId', menuItemId)
                                                                    this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                    this.getNutritionInfo(menuItemId)
                                                                }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a> :   <a title="Nutrition Info"
                                                                href onClick={(e) => {
                                                                    const menuItemId = item.id
                                                                    sessionStorage.setItem('menuItemId', menuItemId)
                                                                    this.setState({ nutritionInfoIsOpen: true, menuItem: { ...item} })
                                                                    this.getNutritionInfo(menuItemId)
                                                                }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a>)}  </span>

                                                        <div>
                                                            <span className="tooltiptext" style={{ marginLeft: 'auto' }}>{(item.desc || '').length > 0 ? item.desc : item.name}</span>
                                                        </div>

                                                    </Fragment>
                                                }</div>  </div> {((this.state.isItemized === 1 || this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={isDisabled} updateQuantity={this.updateQuantity} item={item} /> </div>}
                                        </div>)
                                    })
                                }
                            </Fragment> : null
                    })
                }
                {
                    (eventsObj[MTypes.snack] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.snack]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.snack] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                    const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && this.props.studentData.beforeCare) ? true : false);
                                    const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
                                    const isDisabled = this.validateDates(eventDate);
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    const nutritionInfo = ((item.isNutrAvailable || '') !== '' && item.isNutrAvailable) ? true : false;
                                    return (
                                        <div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                            <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}>
                                                <div className={item.isSelected ? (isDisabled ? "menuItem active disabled" : "menuItem active") : (isDisabled ? "menuItem disabled" : "menuItem")}
                                                    style={allergy ? { backgroundColor: '#f36d6d' } : {}} onClick={(e) => {
                                                        if (e._targetInst.type == 'i') {

                                                        } else {
                                                            this.selectEvent(item);
                                                        }
                                                    }}>{
                                                        <Fragment>
                                                            <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount && item.isSelected ? item.price : item.price))}` + `${" "}`}
                                                                {((nutritionInfo) ?
                                                                    <a title="Nutrition Info" href onClick={(e) => {
                                                                        const menuItemId = item.id
                                                                        sessionStorage.setItem('menuItemId', menuItemId)
                                                                        this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                        this.getNutritionInfo(menuItemId)
                                                                    }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a> : <a title="Nutrition Info" href onClick={(e) => {
                                                                        const menuItemId = item.id
                                                                        sessionStorage.setItem('menuItemId', menuItemId)
                                                                        this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                        this.getNutritionInfo(menuItemId)
                                                                    }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a>)}
                                                            </span>
                                                            <div>
                                                                <span className="tooltiptext" style={{ marginLeft: 'auto' }}>{(item.desc || '').length > 0 ? item.desc : item.name}
                                                                </span></div>
                                                        </Fragment>

                                                    }</div></div>
                                            {((this.state.isItemized === 1 || this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={isDisabled} updateQuantity={this.updateQuantity} item={item} /> </div>}
                                        </div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.dinner] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.dinner]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.dinner] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                    const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && this.props.studentData.beforeCare) ? true : false);
                                    const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
                                    const isDisabled = this.validateDates(eventDate);
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    const nutritionInfo = ((item.isNutrAvailable || '') !== '' && item.isNutrAvailable) ? true : false;
                                    return (
                                        <div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                            <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}>
                                                <div className={item.isSelected ? (isDisabled ? "menuItem active disabled" : "menuItem active") : (isDisabled ? "menuItem disabled" : "menuItem")}
                                                    style={allergy ? { backgroundColor: '#f36d6d' } : {}} onClick={(e) => {
                                                        if (e._targetInst.type == 'i') {

                                                        } else {
                                                            this.selectEvent(item);
                                                        }
                                                    }}>{
                                                        <Fragment>
                                                            <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount && item.isSelected ? item.price : item.price))}` + `${" "}`}
                                                                {((nutritionInfo) ?
                                                                    <a title="Nutrition Info" href onClick={(e) => {
                                                                        const menuItemId = item.id
                                                                        sessionStorage.setItem('menuItemId', menuItemId)
                                                                        this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                        this.getNutritionInfo(menuItemId)
                                                                    }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a> :  <a title="Nutrition Info" href onClick={(e) => {
                                                                        const menuItemId = item.id
                                                                        sessionStorage.setItem('menuItemId', menuItemId)
                                                                        this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                        this.getNutritionInfo(menuItemId)
                                                                    }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a>)}
                                                            </span>
                                                            <div>
                                                                <span className="tooltiptext" style={{ marginLeft: 'auto' }}>{(item.desc || '').length > 0 ? item.desc : item.name}
                                                                </span></div>
                                                        </Fragment>

                                                    }</div></div>
                                            {((this.state.isItemized === 1 || this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={isDisabled} updateQuantity={this.updateQuantity} item={item} /> </div>}
                                        </div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.breakfast] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.breakfast]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.breakfast] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                    const studentIsFreeMeal = ((this.props.studentData.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && this.props.studentData.beforeCare) ? true : false);
                                    const studentIsReducePrice = this.props.studentData.isReducePriceEligible || false;
                                    const isDisabled = this.validateDates(eventDate);
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    const nutritionInfo = ((item.isNutrAvailable || '') !== '' && item.isNutrAvailable) ? true : false;
                                    return (<div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                        <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}>
                                            <div className={item.isSelected ? (isDisabled ? "menuItem active disabled" : "menuItem active") : (isDisabled ? "menuItem disabled" : "menuItem")}
                                                style={allergy ? { backgroundColor: '#f36d6d' } : {}} onClick={(e) => {
                                                    if (e._targetInst.type == 'i') {

                                                    } else {
                                                        this.selectEvent(item);
                                                    }
                                                }}>{
                                                    <Fragment>
                                                        <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount && item.isSelected ? item.price : item.price))}` + `${" "}`}
                                                            {((nutritionInfo) ?
                                                                <a title="Nutrition Info" href onClick={(e) => {
                                                                    const menuItemId = item.id
                                                                    sessionStorage.setItem('menuItemId', menuItemId)
                                                                    this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                    this.getNutritionInfo(menuItemId)
                                                                }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a> : <a title="Nutrition Info" href onClick={(e) => {
                                                                    const menuItemId = item.id
                                                                    sessionStorage.setItem('menuItemId', menuItemId)
                                                                    this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                    this.getNutritionInfo(menuItemId)
                                                                }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a>)}
                                                        </span>

                                                        <div>
                                                            <span className="tooltiptext" style={{ marginLeft: 'auto' }}>{(item.desc || '').length > 0 ? item.desc : item.name}
                                                            </span></div>
                                                    </Fragment>
                                                }</div></div>
                                        {((this.state.isItemized === 1 || this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={isDisabled} updateQuantity={this.updateQuantity} item={item} /> </div>}
                                    </div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.side] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.side]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.side] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                    const isDisabled = this.validateDates(eventDate);
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    const nutritionInfo = ((item.isNutrAvailable || '') !== '' && item.isNutrAvailable) ? true : false;
                                    return (
                                        item.isSideSelect ?
                                            <div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                                <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}>
                                                    <div className={item.isSelected ?
                                                        (isDisabled ? "menuItem active disabled" : "menuItem active") :
                                                        (isDisabled ? "menuItem disabled" : "menuItem")}
                                                        style={allergy ? { backgroundColor: '#f36d6d' } : {}} onClick={(e) => {
                                                            if (e._targetInst.type == 'i') {

                                                            } else {
                                                                this.selectEvent(item);
                                                            }
                                                        }}>{
                                                            <Fragment>
                                                                <span>{`${item.name} ${currency} ${item.price}` + `${" "}`}
                                                                    {((nutritionInfo) ? <a title="Nutrition Info"
                                                                        href onClick={(e) => {
                                                                            const menuItemId = item.id
                                                                            sessionStorage.setItem('menuItemId', menuItemId)
                                                                            this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                            this.getNutritionInfo(menuItemId)
                                                                        }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a> :  <a title="Nutrition Info"
                                                                        href onClick={(e) => {
                                                                            const menuItemId = item.id
                                                                            sessionStorage.setItem('menuItemId', menuItemId)
                                                                            this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                            this.getNutritionInfo(menuItemId)
                                                                        }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a>)}
                                                                </span>
                                                                <div>
                                                                    <span className="tooltiptext" style={{ marginLeft: 'auto' }}>{(item.desc || '').length > 0 ? item.desc : item.name}
                                                                    </span></div>
                                                            </Fragment>

                                                        }</div></div>
                                                {((this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={isDisabled} updateQuantity={this.updateQuantity} item={item} /> </div>}
                                            </div> :
                                            <div className={'menuItem noSelect'}>
                                                <span>{`${item.name} ${currency} ${convertTwoDecimalPoint(item.price)}`}</span>
                                                <span className="tooltiptext">{(item.desc || '').length > 0 ? item.desc : item.name}</span>
                                            </div>
                                    )
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.extra] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.extra]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.extra] || []).sort((a, b) => a.title.localeCompare(b.title)).map(item => {
                                    const isDisabled = this.validateDates(eventDate);
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    const nutritionInfo = ((item.isNutrAvailable || '') !== '' && item.isNutrAvailable) ? true : false;
                                    return (
                                        <div className="row" style={{ display: "flex", alignItems: "flex-start" }}>
                                            <div className="col-xs-10" style={{ paddingRight: '10px', display: "flex", alignItems: "center" }}>
                                                <div className={item.isSelected ?
                                                    (isDisabled ? "menuItem active disabled" : "menuItem active") :
                                                    (isDisabled ? "menuItem disabled" : "menuItem")}
                                                    style={allergy ? { backgroundColor: '#f36d6d' } : {}} onClick={(e) => {
                                                        if (e._targetInst.type == 'i') {

                                                        } else {
                                                            this.selectEvent(item);
                                                        }
                                                    }}>{

                                                        <Fragment><span>{`${item.name} ${currency} ${convertTwoDecimalPoint(item.price)}` + `${" "}`}
                                                            {((nutritionInfo) ? <a title="Nutrition Info"
                                                                href onClick={(e) => {
                                                                    const menuItemId = item.id
                                                                    sessionStorage.setItem('menuItemId', menuItemId)
                                                                    this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                    this.getNutritionInfo(menuItemId)
                                                                }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a> : <a title="Nutrition Info"
                                                                href onClick={(e) => {
                                                                    const menuItemId = item.id
                                                                    sessionStorage.setItem('menuItemId', menuItemId)
                                                                    this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                                                                    this.getNutritionInfo(menuItemId)
                                                                }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle" style={{ color: '#2a5e0d' }}></i>}</a>)}
                                                        </span>
                                                            <div>
                                                                <span className="tooltiptext" style={{ marginLeft: 'auto' }}>{(item.desc || '').length > 0 ? item.desc : item.name}
                                                                </span></div>
                                                        </Fragment>
                                                    }</div></div>
                                            {((this.state.isItemized === 2 || this.state.isItemized === 3) && item.isSelected) && <div className="col-xs-2" style={{ display: "flex", alignItems: "center", padding: 0, marginRight: "10px" }}><CounterComponent readOnly={isDisabled} updateQuantity={this.updateQuantity} item={item} /> </div>}
                                        </div>
                                    )
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.holiday] || []).length > 0 ?

                        (eventsObj[MTypes.holiday] || []).map(item => {
                            return <div className={"menuItem noSchool"}>
                                <span>{item.name}</span></div>
                        })
                        : null
                }
            </Fragment>);
    }
    scrollTop = () => {
        const _pageTop = document.getElementById('pageTop')
        if (_pageTop) {
            if (_pageTop.parentElement)
                _pageTop.parentElement.scrollTo(_pageTop.parentElement.scrollX, 0);
        }
    }
    next(device = 'D') {
        if (device == 'M') {
            let aSlide = this.state.activeSlide;
            aSlide++;
            if (Object.keys(this.state.menuObj).length > aSlide) {
                this.setState({ activeSlide: aSlide })
            }
        }
        else {
            this.slider.slickNext();
        }
    }
    previous(device = 'D') {
        if (device == 'M') {
            let aSlide = this.state.activeSlide
            if (aSlide > 0) {
                aSlide--;
                this.setState({ activeSlide: aSlide })
            }
        } else {
            this.slider.slickPrev();
        }
    }
    onAllergensChange(item) {
        let _menuItemRec = this.state.menuItemRec;

        if ("allergensInfo" in _menuItemRec && _menuItemRec.allergensInfo) {
            if (!_menuItemRec.allergensInfo.includes(item)) {
                _menuItemRec.allergensInfo.push(item)
            } else {
                const index = _menuItemRec.allergensInfo.indexOf(item)
                _menuItemRec.allergensInfo.splice(index, 1)
            }
        } else {
            _menuItemRec.allergensInfo = [item]
        }
        this.setState({ menuItemRec: _menuItemRec })
    }
    render() {
        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            lazyLoad: true,
            beforeChange: (current, next) => {
                this.setState({ activeSlide: next })
            },
            afterChange: (current) => {
                this.setState({ activeSlide: current });
            },
        };
        const { menuObj } = this.state;
        const gradeGroup = groupBy(this.props.gradeList || [], 'value');
        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem" />
                {
                    window.innerWidth <= 500 ?
                        <Fragment>
                            {/* <div className="row" style={{margin: '0'}}>
                    <div className="order-meal-header capitalize">
                        <div className="col-sm-4">
                            <p>Name: <span>{this.props.studentData.firstName + ' ' + this.props.studentData.lastName}</span>
                            </p>
                        </div>
                        <div className="col-xs-6">
                            <p>School: <span>{this.props.studentData.schoolName}</span></p>
                        </div>
                        <div className="col-sm-2">
                            <p>Grade,.....: <span>{ ((gradeGroup[this.props.studentData.gradeName]||[])[0]||{}).label||''}</span></p>
                        </div>
                        <div className="col-md-6 col-xs-6"></div>
                    </div>
                </div> */}

                            {
                                Object.keys(menuObj).map((yearMonth, i) => {
                                    return (<Fragment>
                                        {
                                            i == this.state.activeSlide ?
                                                <div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="text-center">
                                                                <h4 style={{ marginBottom: 0, marginTop: "16px" }} className="pull-left">{moment(yearMonth, 'YYYYMM').format('MMMM-YYYY')}</h4>

                                                                {/* { showM_SLegend? <Fragment><span style={dot4}>M</span><span>Main course</span></Fragment>:null}
                                        {showM_SLegend? <Fragment><span style={dot4}>S</span><span>Sides</span></Fragment>:null}
                                        {showM_SLegend? <Fragment><span style={dot4}>E</span><span>Extras</span></Fragment>:null} */}
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 text-center" style={{ display: "flex", justifyContent: "end" }}>
                                                            {this.state.activeSlide > 0 ? <button type="button" className="btn btn-sm btn-info" style={{ margin: '7px', width: '100%' }}
                                                                onClick={(e) => {
                                                                    this.previous('M');
                                                                }}>Previous</button>
                                                                : null}
                                                            <button type="button" className="btn btn-sm btn-warning" onClick={(e) => {
                                                                this.props.onResetOrderSelection(e)
                                                            }} style={{ margin: '7px', width: '100%' }}>Clear Selections</button>
                                                        </div>
                                                        <div className="col-md-12 text-center" style={{ display: "flex", justifyContent: "end" }}>
                                                            <button type="button" className="btn btn-sm btn-success" onClick={(e) => {
                                                                if (Object.keys(menuObj).length > 1 && this.state.activeSlide < Object.keys(menuObj).length - 1) {
                                                                    this.next('M');
                                                                } else {
                                                                    this.props.onSubmitOrderSelection(e);
                                                                }
                                                            }} style={{ margin: '7px', width: '100%' }}>{Object.keys(menuObj || {}).length > 1 && this.state.activeSlide < Object.keys(menuObj || {}).length - 1 ? 'Continue to Next Month' : 'Review Order'}</button>
                                                        </div>
                                                        <div className="col-md-12 text-center" >  <div id="myID" className="bottomMenu show">
                                                            <ul style={{ display: 'inline-flex' }}>
                                                                <li style={{ paddingRight: '10px', borderRight: '1px solid #ddd' }}>
                                                                    <p className="text-center"
                                                                        style={{ color: '#aa6331', fontSize: '12px', marginBottom: '0px' }}>
                                                                        Paid Amount : <span style={{ fontSize: '20px' }}>{this.props.currency_symbol + '' + parseFloat(this.props.initialPrices[Object.keys(menuObj)[this.state.activeSlide]]).toFixed(2)} </span></p>
                                                                </li>
                                                                <li style={{ paddingLeft: '5px' }}>
                                                                    <p className="text-center"
                                                                        style={{ color: 'darkblue', fontSize: '12px', marginBottom: '0px' }}>
                                                                        Order Amount : <span style={{ fontSize: '20px' }}>{this.props.currency_symbol + '' + (parseFloat(this.props.price[Object.keys(menuObj)[this.state.activeSlide]]) - parseFloat(this.props.initialPrices[Object.keys(menuObj)[this.state.activeSlide]])).toFixed(2)} </span></p>
                                                                </li>
                                                            </ul>

                                                        </div></div>
                                                    </div>
                                                    {
                                                        this.props.paymentProcessPendingBox()
                                                    }
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="table-responsive">
                                                                {/* <FullCalendar id={`mCal-${yearMonth}`}
                                            ref={(c)=>{this[`ref${yearMonth}`]=c}}
                                            height="auto"
                                            defaultDate={moment(yearMonth,'YYYYMM').toDate()}
                                            themeSystem='bootstrap3'
                                            header={false}
                                            //weekends={false}
                                            hiddenDays={this.props.hiddenDays}
                                            editable={false}
                                            resizable={false}
                                            eventClick={ this.selectEvent}
                                            events={menuObj[yearMonth].menuItemsList||[]}
                                            displayEventTime={false}
                                            fixedWeekCount={false}
                                            // droppable: true, // this allows things to be dropped onto the calendar
                                            eventRender={this.eventStyles}                    
                                        /> */}
                                                                <MonthCalender
                                                                    id={`cCal-${yearMonth}`}
                                                                    ref={(c) => { this[`ref-c${yearMonth}`] = c }}
                                                                    hiddenDays={this.props.hiddenDays}
                                                                    defaultDate={moment(yearMonth, 'YYYYMM')}
                                                                    events={menuObj[yearMonth].menuItemsList || []}
                                                                    eventClick={this.selectEvent}
                                                                    renderDayEventList={this.renderDayEventList}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : null}
                                    </Fragment>);
                                })
                            }

                        </Fragment>
                        :
                        <Slider ref={c => (this.slider = c)} {...settings}>
                            {
                                Object.keys(menuObj).map((yearMonth, index) => {
                                    return (<Fragment key={index}>
                                        {/* <div className="row" style={{margin: '0'}}>
                                <div className="order-meal-header capitalize">
                                    <div className="col-sm-4">
                                        <p>Name: <span>{this.props.studentData.firstName + ' ' + this.props.studentData.lastName}</span>
                                        </p>
                                    </div>
                                    <div className="col-sm-6">
                                        <p>School: <span>{this.props.studentData.schoolName}</span></p>
                                    </div>
                                    <div className="col-sm-2">
                                        <p>Grade: <span>{ ((gradeGroup[this.props.studentData.gradeName]||[])[0]||{}).label||''}</span></p>
                                    </div>
                                    <div className="col-md-6 col-sm-6"></div>
                                </div>
                            </div> */}
                                        <div className="row">
                                            <div className="col-md-3" style={{ marginBottom: '10px' }}>
                                                <h4 className="pull-left">{moment(yearMonth, 'YYYYMM').format('MMMM-YYYY')}</h4>
                                            </div>
                                            <div className="col-md-9 " style={{ display: "flex", justifyContent: "end" }}>
                                                {this.state.activeSlide > 0 ? <button type="button" style={{ margin: "0px 8px" }} className="btn btn-sm btn-success pull-left" onClick={(e) => {
                                                    this.slider.slickPrev();
                                                    this.scrollTop();
                                                }}>Previous</button>
                                                    : null}
                                                <button type="button" style={{ margin: "0px 8px" }} className="btn btn-sm btn-warning" onClick={(e) => {
                                                    this.props.onResetOrderSelection(e)
                                                }}>Clear Selections</button>
                                                <button type="button" style={{ margin: "0px 8px" }} className="btn btn-sm btn-success" onClick={(e) => {
                                                    if (Object.keys(menuObj).length > 1 && this.state.activeSlide < Object.keys(menuObj).length - 1) {
                                                        this.slider.slickNext();
                                                    } else {
                                                        this.props.onSubmitOrderSelection(e);
                                                    }
                                                    this.scrollTop();
                                                }}>{Object.keys(menuObj || {}).length > 1 && this.state.activeSlide < Object.keys(menuObj || {}).length - 1 ? 'Continue to Next Month' : 'Review Order'}</button>
                                                <div id="myID" className="bottomMenu show">
                                                    <ul style={{ display: 'inline-flex' }}>
                                                        <li style={{ paddingRight: '10px', borderRight: '1px solid #ddd' }}>
                                                            <p className="text-center"
                                                                style={{ color: '#aa6331', fontSize: '12px', marginBottom: '0px' }}>
                                                                Paid Amount : <span style={{ fontSize: '20px' }}>{this.props.currency_symbol + '' + parseFloat(this.props.initialPrices[Object.keys(menuObj)[this.state.activeSlide]]).toFixed(2)} </span></p>
                                                        </li>
                                                        <li style={{ paddingLeft: '5px' }}>
                                                            <p className="text-center"
                                                                style={{ color: 'darkblue', fontSize: '12px', marginBottom: '0px' }}>
                                                                Order Amount : <span style={{ fontSize: '20px' }}>{this.props.currency_symbol + '' + (parseFloat(this.props.price[Object.keys(menuObj)[this.state.activeSlide]]) - parseFloat(this.props.initialPrices[Object.keys(menuObj)[this.state.activeSlide]])).toFixed(2)} </span></p>
                                                        </li>
                                                    </ul>

                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.props.paymentProcessPendingBox()
                                        }
                                        <div className="row">
                                            <div className="col-md-12">
                                                <MonthCalender
                                                    id={`cCal-${yearMonth}`}
                                                    ref={(c) => { this[`ref-c${yearMonth}`] = c }}
                                                    hiddenDays={this.props.hiddenDays}
                                                    defaultDate={moment(yearMonth, 'YYYYMM')}
                                                    events={menuObj[yearMonth].menuItemsList || []}
                                                    eventClick={this.selectEvent}
                                                    renderDayEventList={this.renderDayEventList}
                                                />
                                            </div>
                                        </div>



                                    </Fragment>);
                                })
                            }
                        </Slider>
                }
                <Modal isOpen={this.state.nutritionInfoIsOpen}
                    onRequestClose={() => this.setState({ nutritionInfoIsOpen: false })}
                    style={infoModalStyles}
                    contentLabel="Nutrition Info"
                >
                    <div>
                        <div className="modal-header">
                            <h4 className="modal-title modal-title-color" id="deleteLabel">Nutrition Info</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <form>
                                    <div className="col-sm-12 col-md-12">
                                        <div className="form-group">
                                            <NutritioninfoNew nutritionCodeVal={this.state.nutritionCodeVal} data={this.state.menuItemRec} nutritionVal={this.state.nutritionVal} servings={this.state.servings} />
                                        </div>

                                        <div className="from-group text-right">
                                            <button type="button" className="btn bg-color-4" onClick={(e) => {
                                                this.hideshowNutritionInfoOpen(e);
                                            }}>Back</button>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </Modal>
                {/* <Modal isOpen={this.state.nutritionInfoIsOpen}
                        onRequestClose={() => this.setState({nutritionInfoIsOpen: false})}
                        style={infoModalStyles}
                        contentLabel="Nutrition Info"
                        ariaHideApp={false}>
                        <div>
                        <div className="modal-header">
                                <h4 className="modal-title modal-title-color" id="deleteLabel">Nutrition Info</h4>
                                </div>
                        <div className="modal-body">
                            <div className="row">                                
                                <div className="col-sm-12 col-md-12">   
                                    <div className="row">   
                                        <div className="col-md-12">
                                            <h4 className="sub-title text-danger" style={{marginBottom:'10px'}} >{'Allergens'}</h4>
                                        </div>
                                        {
                                            (this.state.menuItemRec.allergensInfo||[]).length==0?
                                            <div className='col-md-12 text-center'><span>No data found</span></div>
                                        :
                                    
                                                Object.keys(allergens).filter(itm=>{
                                                    return (this.state.menuItemRec.allergensInfo||[]).includes(allergens[itm].display)
                                                }).map((itm, i)=>{
                                                    return (<div className="mb-4 col-sm-2 col-md-2" style={{display:"inline-block",textAlign:"center",marginBottom:"8px"}}>
                                                            <div className="mb-6 col-sm-12 col-md-12">
                                                                <button onClick={(e)=>{
                                                                   // e.preventDefault()
                                                                   // this.onAllergensChange(allergens[itm].display)
                                                                }} 
                                                                class={`${(this.state.menuItemRec.allergensInfo && this.state.menuItemRec.allergensInfo.includes(allergens[itm].display)) ? 'btn-primary' : 'btn-allergens'}`} 
                                                                style={itm !== 'fish' ? (itm!=='eggs' ? styles.allergensButtonStyle : styles.eggButtonStyle): styles.fishStyle}>
                                                                    <img src={allergens[itm].image} className="img-fluid" alt="..." style={itm !== 'fish' ? (itm!=='eggs' ? styles.imageStyle : styles.eggImageStyle) : styles.fishImageStyle} />
                                                                </button>
                                                                <span className="" style={{
                                                                    //width: '65%',
                                                                    background: 'transparent',
                                                                    border: '0',
                                                                    fontSize:'13px',
                                                                    fontWeight:'bold'
                                                                }}>{allergens[itm].display}</span>
                                                        </div>
                                                        </div> )
                                                    
                                                })
                                                
                                            } </div>
                                    </div> 
                                </div>
                                <div className='row'>               
                                    <div className="col-sm-12 col-md-12">
                                            <NutritionCtrl data={this.state.menuItemRec} onValueChange={(key, value) => {
                                                            let _menuItemRec = this.state.menuItemRec;
                                                            _menuItemRec[key] = value;
                                                            this.setState({ menuItemRec: _menuItemRec })
                                            }} />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="from-group text-right">
                                        <button type="button" className="btn bg-color-4" onClick={(e)=>{
                                                    this.hideshowNutritionInfoOpen(e);
                                        }}>Back</button>
                                    </div>
                                </div>
                            </div> 
                        </div>
                </Modal> */}

                <Modal
                    isOpen={this.state.allergyAlertModal}
                    style={customStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}
                >
                    <div className="row text-center">
                        <h5 style={{ color: 'red' }}>Possible allergy alert</h5>
                    </div>
                    <div>
                        <p>Meal item contains an ingredient matching with kids allergy information. All the matching  items are highlighted in &nbsp; <span
                            style={allergyDot}></span><span> Color.</span></p>
                        <p><b>Disclaimer:</b><br />
                            <strong>By Selecting the meals containing the allergy items, you consent to the fact
                                that the school can serve the meal that day and
                                do not have to replace it. If additional information is needed please contact Food Service Manager {this.state.foodServiceInfo && <Fragment>at - <br /><br /><span style={{ textTransform: 'uppercase' }}>{(this.state.foodServiceInfo || {}).contactPName}</span><br />Ph: <strong>{(this.state.foodServiceInfo || {}).contactPPhone}</strong> <br />Email: <strong>{(this.state.foodServiceInfo || {}).contactPEmail}</strong></Fragment>} </strong>
                        </p>
                        <div className="row text-center">
                            <button style={{ margin: '0px' }}
                                className="btn btn-success btn-sm "
                                onClick={() => {
                                    this.setState({ allergyAlertModal: false });
                                }}>
                                <i className="glyphicon glyphicon-ok"></i> Okay
                            </button>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.isCutoffModeOpen}
                    style={customStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}
                >
                    <div className="row text-center">
                        <h5 style={{ color: 'red' }}>Info</h5>
                    </div>
                    <div>
                        <p>You can not order menu as cut-off date time exceeded.</p>

                        <div className="row text-center">
                            <button style={{ margin: '0px' }}
                                className="btn btn-success btn-sm "
                                onClick={() => this.setState({ isCutoffModeOpen: false })}>
                                <i className="glyphicon glyphicon-ok"></i> Okay
                            </button>
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={this.state.showPrePayAlert} style={customStyles}
                    contentLabel="Activation" ariaHideApp={false} >
                    <div className="row text-center">
                        <h5 style={{ color: 'red' }}>Low Balance</h5>
                    </div>
                    <div>
                        <p>Your Meal Account Balance is not sufficient to place the meal order. We request you to fund your Meal Account and return to order screen to place a new order.</p>
                        <div className="row text-right">
                            <button style={{ margin: '0px' }} className="btn btn-danger btn-sm "
                                onClick={() => {
                                    this.setState({ showPrePayAlert: false });
                                }}>
                                <i className="glyphicon glyphicon-remove"></i> Ok
                            </button>
                        </div>
                    </div>
                </Modal>
            </Fragment>
        )
    }
}
OrderCalender.contextTypes = {
    router: PropTypes.object.isRequired
}
export default OrderCalender



// WEBPACK FOOTER //
// ./src/components/Parent/ManageOrders/orderCalender.jsx